/**
 *  多维分析
 */
export default {
  dbl_multi_title: "Drag & Drop",
  dbl_multi_number_package: "Number Package",
  dbl_multi_related_number_package: "Related Number Package",
  dbl_multi_success_related: "Successfully associated number package",
  dbl_multi_data_source_status: "Data Source",
  dbl_multi_data_source_disabled: "Data sources cannot be modified in Explore mode. To analyze, save a copy of the chart first. To edit, switch to Edit mode.",
  dbl_multi_add_data_source: "Add Data Source",
  dbl_multi_number_package_info: "Number package is a detail subgroup extracted by the user, and the association of number package is an optional item for multidimensional analysis. In the case of associating the number package, only tables that contain specific fields have analytical significance.",
  dbl_multi_filter_conditions: "FILTERS",
  dbl_multi_statistical_indicators: "METRICS",
  dbl_multi_categorical_dimensions: "DIMENSIONS",
  dbl_multi_show_dimensions: "DISPLAY DIMENSION",
  dbl_multi_x_axis: "TEMPORAL X-AXIS",
  dbl_multi_raw_column: "COLUMNS",
  dbl_multi_calculate: "Calculate",
  dbl_multi_preview_sql: "Preview SQL",
  dbl_multi_preview_sql_fail: "Preview SQL failed",
  dbl_multi_operational_guide: "Operational guide",
  dbl_multi_operational_one_title: "Set data source",
  dbl_multi_operational_one_content_first: '1. Click the "Add Data Source" button on the left to open the data source configuration pop-up window;',
  dbl_multi_operational_one_content_second: '2. Click the "Related Number Package " button to open the number package selection pop-up window.',
  dbl_multi_operational_two_title: "Configure calculation conditions",
  dbl_multi_operational_two_content_tip: "Complete the condition configuration in two simple steps:",
  dbl_multi_operational_two_content_first: "1. Select the data table;",
  dbl_multi_operational_two_content_second: "2. Set the data table structure and associate table fields.",
  dbl_multi_operational_three_title: 'Click on "Calculate"',
  dbl_multi_operational_three_content_first: 'Based on the configuration results, drag options to the top area to complete the filtering dimension settings.',
  dbl_multi_operational_three_content_second: 'Click the "Calculate" button to generate visual.',
  dbl_multi_number_package_name: "Package Name",
  dbl_multi_number_package_name_placeholder: "Please select number package",
  dbl_multi_number_package_name_search: "Search number package ",
  dbl_multi_number_package_name_info: "The number package can be empty. After selecting the number package, the detailed fields corresponding to the package will be analyzed.",
  dbl_multi_number_package_sensitive_fields: "Sensitive Fields",
  dbl_multi_add_field_list: "Add Field List",
  dbl_multi_leave_info: "Leave the current analysis task?",
  dbl_multi_explore_leave_info: "Leave the current exploration page?",
  dbl_multi_edit: "Edit",
  dbl_multi_replace: "Replace",
  dbl_multi_delete_filter_2_message: 'Are you sure to delete filter condition 2?',
  dbl_multi_delete_filter_2_des: 'Deleting will lose all contents of filter condition 2.',
  dbl_multi_clear_message: 'Are you sure to clear all options?',
  dbl_multi_clear_des: 'Analysis settings and data logic that were not previously saved will be lost.',
  dbl_multi_save_success: "{name} saved successfully.",
  dbl_multi_save_error: "Chart saving failed with error code {code}",
  dbl_multi_save_as_success: "{name} saved successfully.",
  dbl_multi_copy: "(Copy)",
  dbl_multi_copy_success: "Successfully copied SQL",
  dbl_multi_copy_error: "Failed to copy SQL",
  dbl_multi_add_comparison: "Add contrast item",
  dbl_multi_no_comparison: "This chart does not support comparative analysis",
  dbl_multi_delete_comparison: "Delete contrast item",
  dbl_multi_calculate_info: "The calculation condition has been modified. Please click the Calculate button again to complete the analysis",
  dbl_multi_finish_calculate: "Termination calculation",
  dbl_multi_not_empty_filter: "FILTERS cannot be empty",
  dbl_multi_not_empty_metric: "METRICS cannot be empty",
  dbl_multi_not_empty_dimensions: "DIMENSIONS cannot be empty",
  dbl_multi_ikonw: 'Ok',
  dbl_multi_chart_message: 'Please add the time classification dimension before calculating. Otherwise, the {text} cannot be completed.',
  dbl_multi_chart_select_message: 'The time classification dimension is not selected, and the {text} cannot be made.',

  // 保存弹窗
  dbl_multi_save_chart: "Save Chart",
  dbl_multi_save_as_chart: "Save as Chart",
  dbl_multi_add_analysis: "Add Analyse",
  dbl_multi_edit_analysis: "Edit Analyse",
  dbl_multi_keep_type: "Save Chart",
  dbl_multi_keep_type_replace: "Update",
  dbl_multi_keep_type_save_as: "Save as",
  dbl_multi_replace_info: "The overwrite operation will overwrite the original chart",
  dbl_multi_task_name: "English Name",
  dbl_multi_task_name_placeholder: "Please enter the english name",
  dbl_multi_task_name_validate: "English Name cannot be empty",
  dbl_multi_task_name_length_error: "The content must contain less than 50 chars",
  dbl_multi_task_name_same: "The same english name already exists in the directory. Please rename it",
  dbl_multi_task_name_cn: "Chinese Name",
  dbl_multi_task_name_cn_placeholder: "Please enter the chinese name",
  dbl_multi_task_name_cn_validate: "Chinese name cannot be empty",
  dbl_multi_task_label: "Label",
  dbl_multi_task_label_placeholder: "Please enter the lable",
  dbl_multi_task_label_validate: "Lable cannot be empty",
  dbl_multi_report_label: "Add to Dashboard",
  dbl_multi_report_label_placeholder: "Please select Dashboard",
  dbl_multi_task_permission: "Task Permissions",
  dbl_multi_task_permission_validate: "Please select task permissions",
  dbl_multi_visible_to_me_only: "Visible to Me Only",
  dbl_multi_visible_to_business: "Visible to Business",
  dbl_multi_permission_info: "Please contact @v_blljli to apply for the permission of Datalab administrator for relevant operations",
  dbl_multi_task_custom: "Custom Lable Tag",
  dbl_multi_task_custom_placeholder: "Please enter a name for the new tag",
  dbl_multi_task_label_same: "The same lable tag already exists in the directory. Please rename it",

	
  // 新增字段列表弹窗
  dbl_multi_add_field: "Add calculation field",
  dbl_multi_edit_field: "Modify calculated fields",
  dbl_multi_field_setting: "Field setting",
  dbl_multi_field_existed: "Field List",
  dbl_multi_field_setting_placeholder: "Please directly enter four operation symbols to calculate the new metric, or use SQL function",
  dbl_multi_field_setting_info: "Click fields to auto-add to formula",
  dbl_multi_grammar_check: "Grammar check",
  dbl_multi_filed_zh: "Field name",
  dbl_multi_filed_zh_placeholder: "Enter the field name",
  dbl_multi_filed_zh_valid_empty: "Please enter a field name",
  dbl_multi_filed_valid_length: "Cannot exceed 24 characters",
  dbl_multi_filed_en: "Field English name.",
  dbl_multi_filed_en_placeholder: "Enter the English name",
  dbl_multi_filed_en_valid_empty: "Please enter an English name",
  dbl_multi_filed_valid_used: "Field name already in use",
  dbl_multi_filed_en_valid: "Please enter a legal English name",
  dbl_multi_filed_type: "Field Type",
  dbl_multi_filed_type_placeholder: "Select field type",
  dbl_multi_filed_type_valid: "Please select field type",
  dbl_multi_filed_note: "Field remarks (optional)",
  dbl_multi_filed_note_placeholder: "Enter field comments",
  dbl_multi_filed_calculation_formula: "Please enter the calculation formula",
  dbl_multi_filed_sql_error: "SQL syntax error:",
  dbl_multi_filed_sql_success: "SQL verification succeeded",
  dbl_multi_filed_add_success: "Successfully added",
  dbl_multi_filed_edit_success: "Modified successfully",
  dbl_multi_filed_edit: "Edit",
  dbl_multi_filed_delete: "Delete",
	
  dbl_multi_delete_table: "Are you sure to delete the data table?",
  dbl_multi_delete_table_info: "Delete data table",
  dbl_multi_re_analysis: "will be re-analyzed",
  dbl_multi_unnamed_chart_title: 'Unnamed Chart',
	
  dbl_multi_rename: 'Rename',
  dbl_multi_convert_to_dimension: 'Convert to Dimension',
  dbl_multi_convert_to_metric: 'Convert to Metric',
  dbl_multi_field_type: 'Field type',
  dbl_multi_string: 'String',
  dbl_multi_date: 'Datetime',
  dbl_multi_time: 'Time',
  dbl_multi_number: 'Int',
  dbl_multi_float: 'Float',
  dbl_multi_decimal_places: 'Decimal places',
  dbl_multi_percent: 'Percentage',
  dbl_multi_dimension_value_settings: 'Dimension value settings',
  dbl_multi_origin: 'Original value',
  dbl_multi_associated_dimension_table: 'Associated dimension table',
  dbl_multi_system: 'Automatic matching',
  dbl_multi_customize: 'Custom association',
  dbl_multi_include_dimension_total_value: 'Include dimension total value',
  dbl_multi_include: 'Include',
  dbl_multi_exclude: 'Exclude',
  dbl_multi_check_date_success: 'Conversion successful',
  dbl_multi_check_date_fail: 'Unable to convert to date type',
  dbl_multi_check_date_retry: 'Verification failed, please try again later',
  
  dbl_multi_exploration: 'exploration ',
  
  dbl_multi_query_mode: 'Query mode:',
  dbl_multi_aggregation: 'Aggregation mode',
  dbl_multi_detail: 'Detail mode',
  dbl_multi_query_mode_info: 'Show the raw detailed data of the data source',
  
  dbl_multi_display_format: 'Display Format: ',
  dbl_multi_unit: 'Numerical Unit',
  dbl_multi_unit_bmk: 'BMK',
  dbl_multi_unit_bmk_info: 'Auto-convert values by BMK units',
  dbl_multi_unit_thousandsDecimals: 'Original Value',
  dbl_multi_decimal: 'Decimal Places',
  dbl_multi_not_applicable: 'Not Applicable',

  dbl_multi_database_host: 'Host',
  dbl_multi_database_port: 'Port',

  dbl_multi_batch_add_table: 'Table',
  dbl_multi_batch_add_field_list: 'Field List',
  dbl_multi_batch_add_custom_field: 'Custom Field',
  dbl_multi_batch_add_sensitive_disabled: 'Sensitive field, cannot be added here',
  dbl_multi_batch_add_xaxis_date_only: 'X axis only accepts date fields',
  dbl_multi_batch_add_limit_disabled: 'Chart field limit reached',
  dbl_multi_batch_add_show_dimension_no_datetime:
    'Display dimension cannot use date/time fields',
  dbl_multi_batch_add_skipped_sensitive: '{count} sensitive field(s) cannot be added here',
  dbl_multi_batch_add_skipped_limit: '{count} field(s) skipped due to chart limit',
  dbl_multi_batch_add_trend_dimension_date_only:
    '{count} non-date field(s) cannot be the first category dimension',
  dbl_multi_batch_add_trend_dimension_invalid:
    'The first category dimension must be a date field',
};